export var SET_PWA_PROMPT_ANDROID_EVENT = 'SET_PWA_PROMPT_ANDROID_EVENT';
export var setPwaPromptAndroidEventAction = function (payload) { return ({
    type: SET_PWA_PROMPT_ANDROID_EVENT,
    payload: payload,
}); };
export var SET_PWA_PROMPT_IOS = 'SET_PWA_PROMPT_IOS';
export var setPwaPromptIosShownAction = function (payload) { return ({
    type: SET_PWA_PROMPT_IOS,
    payload: payload,
}); };
export var OPEN_PWA_MODAL_IOS = 'OPEN_PWA_MODAL_IOS';
export var openIosPwaModalAction = function () { return ({
    type: OPEN_PWA_MODAL_IOS,
}); };
export var CLOSE_PWA_MODAL_IOS = 'CLOSE_PWA_MODAL_IOS';
export var closeIosPwaModalAction = function () { return ({
    type: CLOSE_PWA_MODAL_IOS,
}); };
export var SET_MANIFEST = 'SET_MANIFEST';
export var setManifestAction = function (payload) { return ({
    type: SET_MANIFEST,
    payload: payload,
}); };
export var FETCH_MANIFEST = 'FETCH_MANIFEST';
export var fetchManifestActionSaga = function (payload) { return ({
    type: FETCH_MANIFEST,
    payload: payload,
}); };
